/**
 * @desc 换货
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.PackageExchangeGoodsDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderPackageItem/exchangeGoods`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
